<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des événements"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/event/list"
                :duplicate="dataDuplicate"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/event"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'événement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet événement?')"></ModalTrash>
        <ModalDuplicate
                ref="duplicate"
                root="/event/duplicate"
                @onDuplicateSuccess="onDuplicateSuccess"
                :caption="Core.Definition.getDefinition('Duplication de l\'événement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir dupliquer cet événement?')"></ModalDuplicate>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    import ModalDuplicate from '../../components/ModalDuplicate'
    export default {
        name: 'EventList',
        components: {
            DynamicCardList,
            ModalTrash,
            ModalDuplicate
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Type'),
                        key: 'type',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Responsables'),
                        key: 'assignedUsers',
                        sortable: false
                    },
                    {
                        label: Core.Definition.getDefinition('Max.'),
                        key: 'max',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Local'),
                        key: 'local',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'type'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'assignedUser'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'local'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        },
                        {
                            id: 'type',
                            type: 'select',
                            label: Core.Definition.getDefinition('Type'),
                            value: null,
                            onSelect: function() {}
                        },
                        {
                            id: 'assignedUser',
                            type: 'text',
                            label: Core.Definition.getDefinition('Responsable'),
                            value: ''
                        },
                        {
                            id: 'local',
                            type: 'text',
                            label: Core.Definition.getDefinition('Local'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                },
                dataDuplicate: {
                    show: true,
                    text: '<button class="btn btn-sm btn-light"><i class="fa fa-copy"></i></button>',
                    onClick:  this.clickDuplicate
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/evenement/evenements/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            clickDuplicate(value, cell, row) {
                this.$refs.duplicate.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            },
            onDuplicateSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
